import React, { useEffect, useState } from "react";
import "../css/css_layouts/Sidebar.css";
import Logo from "../assets/rajidaholdings_logo.jpeg";
import {
  FaTachometerAlt,
  FaHandsHelping,
  FaLocationArrow,
  FaUserAlt,
  FaList,
  FaCreditCard,
  FaFileInvoiceDollar,
  FaShareAlt,
  FaEye,
  FaEyeSlash,
  FaBars,
  FaTicketAlt,
  FaBusinessTime,
  FaFileAlt,
  FaMoneyCheckAlt,
  FaTasks
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdManageAccounts } from "react-icons/md";
import { BiLogOut } from "react-icons/bi";
import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import PopupMessage from "./PopupMessage";

const Sidebar = ({ isOpen, setIsOpen, handleLogout, headerVisible, toggleHeader }) => {
  const [userType, setUserType] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setUserType(Cookies.get("userType"));
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname, setIsOpen]);

  const showComingSoonMessage = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const isClientRoute = (pathname) => {
    const clientRoutes = [
      "/c-dashboard",
      "/finance",
      "/Tasks",
      "/create-issue",
      "/schedules",
      "/account",
      "/referrals",
    ];
    return clientRoutes.some((route) => pathname.startsWith(route));
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="hamburger-icon" onClick={() => setIsOpen(!isOpen)}>
        <FaBars />
      </div>

      <div className="sidebar-header">
        <div className="logo">
          <img src={Logo} alt="Company Logo" />
        </div>
        <div className="logo-name">Rajida</div>
      </div>

      <ul className="sidebar-menu">
        <Link
          to={
            userType === "management"
              ? "/management-dashboard"
              : ["TSO Online", "Online TSO"].includes(userType)
              ? "/dashboard"
              : "/c-dashboard"
          }
        >
          <li>
            <FaTachometerAlt className="icon" />
            <span className="menu-text">Dashboard</span>
          </li>
        </Link>

        {/* Management specific routes */}
        {userType === "management" && (
          <>
            <Link to="/customer-service-progress">
              <li>
                <FaTasks className="icon" />
                <span className="menu-text">Service Progress</span>
              </li>
            </Link>
            <Link to="/management-tso-location">
              <li>
                <FaLocationArrow className="icon" />
                <span className="menu-text">TSO Location</span>
              </li>
            </Link>
            <Link to="/all-invoice">
              <li>
                <FaFileInvoiceDollar className="icon" />
                <span className="menu-text">Invoices</span>
              </li>
            </Link>
            <Link to="/client-manage">
              <li>
                <FaHandsHelping className="icon" />
                <span className="menu-text">Client Management</span>
              </li>
            </Link>
            <Link to="/tso-management">
              <li>
                <MdManageAccounts className="icon" />
                <span className="menu-text">TSO Management</span>
              </li>
            </Link>
            <Link to="/tickets-managment">
              <li>
                <FaTicketAlt className="icon" />
                <span className="menu-text">Tickets</span>
              </li>
            </Link>
            <Link to="/schedule-managment">
              <li>
                <FaBusinessTime className="icon" />
                <span className="menu-text">Schedules</span>
              </li>
            </Link>
            <Link to="/document-managment">
              <li>
                <FaFileAlt className="icon" />
                <span className="menu-text">Documents</span>
              </li>
            </Link>
            <Link to="/onsite-payments-managment">
              <li>
                <FaMoneyCheckAlt className="icon" />
                <span className="menu-text">Onsite Payments</span>
              </li>
            </Link>
            <Link to="/tso-expenses-managment">
              <li>
                <FaMoneyCheckAlt className="icon" />
                <span className="menu-text">TSO Expenses</span>
              </li>
            </Link>
            <Link to="/ds-managment">
              <li>
                <FaLocationDot className="icon" />
                <span className="menu-text">DS Management</span>
              </li>
            </Link>
          </>
        )}

        {["TSO Online", "Online TSO"].includes(userType) && (
          <>
            <Link to="/client-management">
              <li>
                <FaHandsHelping className="icon" />
                <span className="menu-text">Client Management</span>
              </li>
            </Link>
            <Link to="/TSOScheduleViewer">
              <li>
                <FaList className="icon" />
                <span className="menu-text">Schedules</span>
              </li>
            </Link>
            <Link to="/referrals">
              <li>
                <FaShareAlt className="icon" />
                <span className="menu-text">Referrals</span>
              </li>
            </Link>
          </>
        )}

        {!["TSO Online", "Online TSO", "management"].includes(userType) && (
          <>
            <Link to="/finance">
              <li>
                <FaCreditCard className="icon" />
                <span className="menu-text">Finance</span>
              </li>
            </Link>
            <Link to="/referrals">
              <li>
                <FaShareAlt className="icon" />
                <span className="menu-text">Referrals</span>
              </li>
            </Link>
          </>
        )}
      </ul>

      <div className="sidebar-footer">
        <ul>
          <li className="hide-header-button" onClick={toggleHeader} style={{ cursor: 'pointer' }}>
            {headerVisible ? <FaEyeSlash className="icon" /> : <FaEye className="icon" />}
            <span className="menu-text">{headerVisible ? 'Hide Header' : 'Show Header'}</span>
          </li>
          <Link to="/account">
            <li>
              <FaUserAlt className="icon" />
              <span className="menu-text">Account</span>
            </li>
          </Link>
          <li>
            <button
              onClick={handleLogout}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                cursor: "pointer",
                padding: 0,
              }}
            >
              <BiLogOut className="icon" />
              <span className="menu-text">Log Out</span>
            </button>
          </li>
        </ul>
      </div>

      {showPopup && (
        <PopupMessage message="Coming Soon!" onClose={closePopup} />
      )}
    </div>
  );
};

export default Sidebar;